import { CountryInfo } from 'pages/insights-pro/country-tab/model';
import { Pagination } from '@mui/material';
import { useState } from 'react';
import * as TopList from 'components/Layout/Tiles/ListContainer';
import { TileContent } from 'components/Layout/PageContainer';
import { Measure } from 'services/model/model.service';
import { EmptyState } from 'components/EmptyState';

interface TopPerformingCountriesProps {
  countries: CountryInfo[];
  isComparisonActive: boolean;
  gmvMeasure: Measure;
  qtyMeasure: Measure;
}

export function TopPerformingCountries({
  countries,
  isComparisonActive,
  gmvMeasure,
  qtyMeasure,
}: TopPerformingCountriesProps) {
  const [pageSize] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  if (countries.length === 0) {
    return <EmptyState />;
  }
  return (
    <TileContent className="flex flex-col justify-between items-center px-2" data-testid="top-performing-countries">
      <TopList.ListContainer>
        {countries.slice((currentPage - 1) * pageSize, currentPage * pageSize).map(country => (
          <TopList.ListRow key={country.name}>
            {/* Country Column */}
            {country.code ? (
              <TopList.NameCell countryCode={country.code} name={country.name} color={country.color} />
            ) : (
              ''
            )}
            {/* GMV Column */}
            <TopList.MetricCell
              measure={gmvMeasure}
              value={gmvMeasure.getValue(country.entry.values)}
              comparisonValue={gmvMeasure.getValue(country.entry.compareValues)}
              unit={gmvMeasure.metric.unit}
              comparisonActive={isComparisonActive}
              size="lg"
            />
            {/* Quantity Column */}
            <TopList.MetricCell
              measure={qtyMeasure}
              value={qtyMeasure.getValue(country.entry.values)}
              comparisonValue={qtyMeasure.getValue(country.entry.compareValues)}
              unit={qtyMeasure.metric.unit}
              comparisonActive={isComparisonActive}
            />
          </TopList.ListRow>
        ))}
      </TopList.ListContainer>
      {Math.ceil(countries.length / pageSize) > 1 && (
        <Pagination
          className="mt-4"
          size="small"
          count={Math.ceil(countries.length / pageSize)}
          page={currentPage}
          onChange={(_event, page) => setCurrentPage(page)}
        />
      )}
    </TileContent>
  );
}
